module.exports = __webpack_public_path__ + "img/visa_mastercard.70314eaf.svg";